<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-arrow-up"
    viewBox="0 0 32 32"
  >
    <path
      fill="#fff"
      d="M5.016,23.5l-1.516-1.617L16.001,8.5l12.5,13.383L26.992,23.5L16.001,11.742L5.016,23.5z"
    />
  </svg>
</template>
<script>
export default {};
</script>
